var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRefreshCw(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5923_14434)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.1665 3.33398V8.33398H14.1665",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.833496 16.666V11.666H5.8335",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.92516 7.49998C3.3478 6.30564 4.06611 5.23782 5.01305 4.39616C5.96 3.55451 7.10472 2.96645 8.3404 2.68686C9.57608 2.40727 10.8625 2.44527 12.0795 2.79729C13.2965 3.14932 14.4045 3.80391 15.3002 4.69998L19.1668 8.33331M0.833496 11.6666L4.70016 15.3C5.59579 16.1961 6.70381 16.8506 7.92084 17.2027C9.13787 17.5547 10.4242 17.5927 11.6599 17.3131C12.8956 17.0335 14.0403 16.4455 14.9873 15.6038C15.9342 14.7621 16.6525 13.6943 17.0752 12.5",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5923_14434"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefreshCw);
export default __webpack_public_path__ + "static/media/refresh-cw.b78b7c0b016c7ff3baf3ad84f2ff5f79.svg";
export { ForwardRef as ReactComponent };